import { api } from 'api'
import { useMutation } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useUserItemDelete = () => {
  return useMutation({
    mutationFn: (data) => api.keycloak.deleteUserItem(data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось удалить пользователя',
        type: 'error',
        duration: 9000,
        isClosable: true,
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Пользователь успешно удален',
        type: 'success',
      })
    }
  })
}
